export default "__VITE_ASSET__DwN8Sm14__"